import Vue from 'vue';
import {
  Radio,
  Button,
  Input,
  DatePicker,
  AutoComplete,
  Progress,
  Form,
  Checkbox,
  Modal,
  Popover,
  Collapse,
  Icon,
  List,
  Spin,
  Select,
  Table,
} from 'ant-design-vue';

import '@/assets/styles/antd.scss';

const components = [
  Radio.Group,
  Checkbox,
  Radio.Button,
  Button,
  Input,
  Input.TextArea,
  List,
  List.Item,
  Input.Password,
  DatePicker,
  DatePicker.MonthPicker,
  AutoComplete,
  Progress,
  Form,
  Form.Item,
  Modal,
  Popover,
  Collapse,
  Collapse.Panel,
  Icon,
  Spin,
  Select,
  Select.Option,
  Table,
];

components.forEach((component) => Vue.component(component.name, component));
